import { type BuilderPage } from '@/types/schema/BuilderPage';
import { type KnackObject, type KnackObjectProfileKey } from '@/types/schema/KnackObject';
import { usePagesQuery } from '@/hooks/api/queries/usePagesQuery';
import { useObjectHelpers } from '@/hooks/helpers/useObjectHelpers';

export function usePageHelpers() {
  const { getUserRoleObjectFromProfileKey } = useObjectHelpers();
  const { data: pages = [] } = usePagesQuery();

  const getPageBySlug = (slug: string) => pages.find((page) => page.slug === slug);

  const getPageRoleObjects = (page: BuilderPage, includeAccountsObject = false) => {
    const roleObjects: KnackObject[] = [];

    const allowedProfileKeys: KnackObjectProfileKey[] = page.allowedProfileKeys || [];

    if (includeAccountsObject) {
      allowedProfileKeys.push('all_users');
    }

    allowedProfileKeys.forEach((profileKey) => {
      const roleObject = getUserRoleObjectFromProfileKey(profileKey);

      if (roleObject) {
        roleObjects.push(roleObject);
      }
    });

    return roleObjects;
  };

  return {
    getPageBySlug,
    getPageRoleObjects
  };
}
